module.exports = __webpack_public_path__ + "static/media/board_arrow.54529900.svg";